import { AnyAction } from 'redux';
import { GlobalActions, ZaehlstueckeReceived } from '@ps20-frontend/shop-integration-redux';

export const effektiveZaehlstueckeReducer = function (
  sectionState: number = null,
  action: AnyAction,
): number {
  switch (action.type) {
    case GlobalActions.ZAEHLSTUECKE_RECEIVED: {
      const actionPayload: ZaehlstueckeReceived = action.payload;
      return actionPayload.effektiveZaehlstuecke;
    }
    default:
      return sectionState;
  }
};
